import React from 'react';
import Immutable from 'immutable'
import { bindActionCreators }  from 'redux';
import { connect }  from 'react-redux';
import Translator from 'bazinga-translator';

import Person from './person.jsx';
import NewPerson from './new-person.jsx';

import * as ClientActions from '../actions/clients-actions';

class Clients extends React.Component {
    constructor() {
        super();
    }

    componentDidMount() {
        const {clientActions} = this.props;
        clientActions.initValues();
    }

    componentDidUpdate(prevProps, prevState){
        const prevPropsImmutable = Immutable.fromJS(prevProps);
        const currentPropsImmutable = Immutable.fromJS(this.props);
        if(currentPropsImmutable !== prevPropsImmutable) {
            this.setValueToInput('app_client_contactPersons',this.props);
        }
    }

    setValueToInput(id, nextProps) {
        let hiddenInput = document.getElementById(id),
            newValue = JSON.stringify(nextProps.clients.persons);

        if (hiddenInput.value !== newValue) {
            hiddenInput.value = newValue
        }
    }

    render() {
        console.log(this.props);
        console.log()
        const { clients, clientActions } = this.props;
        return (
        <div>
            <h3>{Translator.trans('edit_mode.modal.clients.contact_person.header', [], 'app')}</h3>

            {clients.persons.map((person, i)=>{
                return (
                <Person
                    key={person.key}
                    person={person}
                    persons={clients.persons}
                    actions={clientActions}
                />
                )
            })}

            <NewPerson persons={clients.persons} actions={clientActions}/>
        </div>)
    }
}


function mapStateToProps(state) {
    return {
        clients: state.clients
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clientActions: bindActionCreators(ClientActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Clients);


// WEBPACK FOOTER //
// ./src/_app/clients/components/clients.jsx